<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-3 pr-1 mb-3">
                    <VueCtkDateTimePicker formatted='ll' v-validate="'required'" format="YYYY-MM-DD"  :range="true" name="date" :label="'সময়সীমা নির্বাচন করুন'" v-model="date" />
                    <p v-show="errors.has('date')" style="color:red">* {{ errors.first('date') }}</p>
                </div>
                <div class="col-3 pl-1 pr-1 mb-3">
                    <select v-model="status" class="form-control formInput">
                        <option value="">স্ট্যাটাস নির্বাচন করুন</option>
                        <option value="0">অচল/পেন্ডিং</option>
                        <option value="1">সচল</option>
                        <option value="2">বাতিলকৃত</option>
                    </select>
                </div>
                <div class="col-3 pl-1 pr-1 mb-3">
                    <select v-model="ward"  name="word_no" class="form-control formInput" >
                        <option value="">ওয়ার্ড সিলেক্ট করুন</option>
                        <option v-for="(ward,key) in wards" :key="key" :value="ward.id">{{ ward.ward_name_bng}}{{ ward.name}}</option>
                    </select>
                </div>
                <div class="col-3 pl-1 mb-3">
                    <select @change="getSelectService()" v-model="select_dia"  class="form-control formInput">
                        <option value="">লাইনের ব্যাস</option>
                        <option value="0.5">0.5 ইঞ্চি</option>
                        <option value="0.75">0.75 ইঞ্চি</option>
                        <option value="1.00">1 ইঞ্চি</option>
                        <option value="1.5">1.5 ইঞ্চি</option>
                        <option value="1.75">1.75 ইঞ্চি</option>
                        <option value="1">2 ইঞ্চি</option>
                    </select>
                </div>
                <div class="col-3 pr-1 mb-3">
                    <select v-model="service_id" name="Diameter" class="form-control formInput">
                        <option value="">লাইনের ধরন</option>
                        <option :value="diameter.id" v-for="(diameter,key) in service_list" :key="key">{{diameter.name}}&nbsp;{{diameter.diameter}} ইঞ্চি</option>
                    </select>
                </div>
                <div class="col-3 pl-1 pr-1 mb-3">
                    <button @click.prevent="getResults()" class="btn btn-success my-2 my-sm-0 mr-2 formInput pull-left" >Search</button>
                    <button @click.prevent="download()" class="btn btn-success my-2 my-sm-0 formInput pull-left">Export</button>
                </div>
                <div class="col-6 pl-1 mb-3">
                    <a class="btn btn-info pull-right" href="/report"><i class="fa fa-angle-left" aria-hidden="true"></i> Back</a>
                </div>
            </div>
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">একাউন্ট</th>
                        <th scope="col">গ্রাহকের নাম </th>
                        <th scope="col">গ্রাহকের ধরন</th>
                        <th scope="col" class="text-center">মোবাইল</th>
                        <th scope="col" class="text-center">ওয়ার্ড</th>
                        <th scope="col" class="text-center">স্ট্যাটাস</th>
                        <th scope="col" class="text-center">সংযোগ তারিখ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(datum,key) in data.data" :key="key">
                        <td v-if="data.from">{{data.from+key}}</td>
                        <td>{{datum.account_no}}</td>
                        <td>{{datum.user_name}}</td>
                        <td>{{datum.grahoker_dhoron}} {{ datum.diameter}} ইঞ্চি</td>
                        <td class="text-center">{{datum.mobile_number}}</td>
                        <td class="text-center">{{ datum.ward_no}}</td>
                        <td class="text-center">{{datum.status == 0?"অচল/পেন্ডিং":''}}{{datum.status == 1?"সচল":''}}{{datum.status == 2?"বাতিল":''}}</td>
                        <td class="text-center">{{datum.created}}</td>
                    </tr>
                </tbody>
            </table>
            <hr>
            <div class="row">
                <div class="col-8">
                    <nav aria-label="Page navigation example">
                        <pagination :limit="5" :data="data" @pagination-change-page="loadContents"></pagination>
                    </nav>
                </div>
                <div class="col-4 text-right">
                    গ্রাহক সংখ্যা : {{ data.total }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { mapGetters } from "vuex"
import pagination from 'laravel-vue-pagination'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
import axios from 'axios'

export default {
    data(){
        return {
            date:'',
            name:'',
            data:{},
            status:'',
            //type:'',
            ward:'',
            service_id:'',
            service_list:[],
            select_dia:'',
            diameter_list : [],
        }
    },
    methods:{
        async loadContents(page){
            var start = ''
            var end = ''
            if(this.date){
                start = this.date.start
                end = this.date.end
            }
            var data = {ward:this.ward,start,end,status:this.status,service_id:this.service_id};

            axios.post('/api/water-new-grahok?page='+page,data).then(response=>{
                this.data = response.data;
                //console.log(response.data)
            })
        },
        async getResults(page = 1){
            this.$validator.validateAll().then( result =>{
                if(result){
                    this.loadContents(page)
                }
            })
        },
        getSelectService(){
            this.service_list = []
            this.service_id = ''
            axios.get('api/project-all').then(response=>{
                this.diameter_list = response.data
                this.diameter_list.forEach(element=>{
                    if(element.diameter == parseFloat(this.select_dia)){
                        this.service_list.push(element)
                    }
                })
            })
        },
        download(){
            this.$validator.validateAll().then( result =>{
                if(result){
                    let getUserInfo = JSON.parse(localStorage.getItem('user'))
                    let loggedUser = getUserInfo.name
                    var start = ''
                    var end = ''
                    var download = 'download'
                    if(this.date){
                        start = this.date.start
                        end = this.date.end
                    }

                    window.open(`${axios.defaults.baseURL}/api/water-new-grahok?ward=${this.ward}&download=${download}&start=${start}&end=${end}&service_id=${this.service_id}&status=${this.status}&loggeduser=${loggedUser}`)
                }
            })
        },
        wardLists(){
            var invoice_type = 'water-billing'
            this.$store.dispatch('WARD_LIST',{invoice_type})
        },
    },
    mounted(){
        this.wardLists();
        this.loadContents(1)
    },
    computed:{
        ...mapGetters(['wards'])
    },
    components: {
        VueCtkDateTimePicker,
        pagination
    }
}
</script>
<style scoped>
    .formInput{ height: 41px;}
    .date-time-picker label,.card{font-family: 'Hind Siliguri Light' !important; font-size: 16px;}
    .form-control{ font-size: 16px;}
    .btn-info{ color: #fff; text-transform: capitalize; height: 42px; line-height: 42px; padding: 0rem 0.75rem;}
</style>
